document.addEventListener('bss_b2b:rerendered', ()=> {
  if(BSS_B2B){
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
})

function caculateSubtotalPDP() {
    const priceCell = document.querySelector(".price--medium .price__regular");
    const variantId = priceCell?.getAttribute("bss-b2b-variant-id");

    if (!variantId) return;

    const spans = priceCell?.querySelectorAll("span");
    const priceText = spans?.[1]?.textContent?.trim() || "";

    const numericPrice = Number(priceText.replace(/[^\d]/g, "")) || 0;

    const qtyInput = document.querySelector(
      `.quantity__container input.quantity__input`
    );
    const quantity = parseFloat(qtyInput?.value || 1);

    const subtotalValue = numericPrice * quantity;

    const formattedSubtotal = subtotalValue.toLocaleString("vi-VN"); 

    const subtotalPrice = document.querySelector(
      `.productView-subtotal .money-subtotal[bss-b2b-variant-id="${variantId}"]`
    );

    const currencySymbol = priceText.replace(/[\d.,\s]/g, "");
    subtotalPrice.textContent = `${formattedSubtotal}${currencySymbol}`;
}


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const hasCpRule = Boolean(
      BSS_B2B?.cp?.utils?.common?.getCustomerAppliedRules().length
    );

    if (!hasCpRule) {
      return;
    }

    caculateSubtotalPDP();
  }, 3000);
});